package data

import com.kinoshazam.data.GlobalStateRepository
import data.network.result.VideoResult
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import data.network.result.SearchResponse
import models.Cast
import models.Genre
import models.IdentifyTextRequest
import models.IdentifyTextResponse
import models.PersonDetails
import models.VideoDetails

class VideoRepository(
    private val httpClient: HttpClient,
    private val globalStateRepository: GlobalStateRepository,
) {

    val local: String get() = globalStateRepository.appLanguage.value.locale

    suspend fun getReleaseSoonMovies(page: Int): List<VideoDetails>? {
        val response = httpClient.get(urlString = "movie/upcoming") {
            parameter("page", page)
            parameter("language", local)
        }.body<VideoResult<List<VideoDetails>>>()

        return response.result
//        return response.movies?.map { it.map(getImageUrl()) }
    }

    suspend fun getNewMovies(page: Int, genre: String? = null): List<VideoDetails>? {
        val response = httpClient.get(urlString = "movie/popular") {
            parameter("page", page)
            parameter("language", local)
            parameter("genre", genre)
        }.body<VideoResult<List<VideoDetails>>>()

        return response.result
//        return response.movies?.map { it.map(getImageUrl()) }
    }

    suspend fun getNewTvShows(page: Int, genre: String?): List<VideoDetails>? {
        val response = httpClient.get(urlString = "tv/popular") {
            parameter("page", page)
            parameter("language", local)
            parameter("genre", genre)
        }.body<VideoResult<List<VideoDetails>>>()

        return response.result
//        return response.movies?.map { it.map(getImageUrl()) }
    }

    suspend fun getMovieDetails(videoId: Int, language: String = local): VideoDetails? {
        val response =
            httpClient.get(urlString = "movie/details") {
                parameter("language", language)
                parameter("videoId", videoId)
            }.body<VideoResult<VideoDetails>>()
        return response.result
//        return response.map(getImageUrl())
    }

    suspend fun getTvShowDetails(videoId: Int, language: String = local): VideoDetails? {
        val responseTv =
            httpClient.get(urlString = "tv/details") {
                parameter("language", language)
                parameter("videoId", videoId)
            }.body<VideoResult<VideoDetails>>()

//        val response =
//            httpClient.get(urlString = "tv/details/episodes") {
//                parameter("videoId", videoId)
//                parameter("season", responseTv.result?.seasons?.firstOrNull()?.seasonNumber ?: 0)
//                parameter("language", local)
//            }.body<VideoResult<VideoDetails.TvShow.Season>>()

        return responseTv.result
//        return responseTv.map(getImageUrl(), response.episodes)
    }

    suspend fun getTvSeasonDetails(videoId: Int, seasonNumber: Int): VideoDetails.Season? {
        val response =
            httpClient.get(urlString = "tv/details/episodes") {
                parameter("videoId", videoId)
                parameter("season", seasonNumber)
                parameter("language", local)
            }.body<VideoResult<VideoDetails.Season>>()
        return response.result
//        return response.map(getImageUrl())
    }

    suspend fun getSimilarVideos(videoId: Int): List<VideoDetails>? {
        val response = httpClient.get(urlString = "movie/similar") {
            parameter("page", 1)
            parameter("videoId", videoId)
            parameter("language", local)
        }.body<VideoResult<List<VideoDetails>>>()

        return response.result
//        return response.movies?.map { it.map(getImageUrl()) }
    }

    suspend fun getSimilarTv(videoId: Int): List<VideoDetails>? {
        val response = httpClient.get(urlString = "tv/similar") {
            parameter("page", 1)
            parameter("language", local)
            parameter("videoId", videoId)
        }.body<VideoResult<List<VideoDetails>>>()

        return response.result
//        return response.movies?.map { it.map(getImageUrl()) }
    }

    suspend fun getMovieCast(videoId: Int): Cast? {
        val response = httpClient.get(urlString = "movie/cast") {
            parameter("page", 1)
            parameter("language", local)
            parameter("videoId", videoId)
        }.body<VideoResult<Cast>>()

        return response.result //.map(getImageUrl())
    }

    suspend fun getTvCast(videoId: Int): Cast? {
        val response = httpClient.get(urlString = "tv/cast") {
            parameter("page", 1)
            parameter("language", local)
            parameter("videoId", videoId)
        }.body<VideoResult<Cast>>()

        return response.result
    }

    suspend fun getTrendingMovies(
        timeWindow: String = "week",
        page: Int = 1
    ): List<VideoDetails>? {
        val response = httpClient.get(urlString = "movie/trending") {
            parameter("page", page)
            parameter("language", local)
            parameter("time", timeWindow)
        }.body<VideoResult<List<VideoDetails>>>()
        return response.result
//        return response.movies?.map { it.map(getImageUrl()) }
    }

    suspend fun getTrendingTv(
        timeWindow: String = "week",
        page: Int = 1
    ): List<VideoDetails>? {
        val response = httpClient.get(urlString = "tv/trending") {
            parameter("page", page)
            parameter("language", local)
            parameter("time", timeWindow)
        }.body<VideoResult<List<VideoDetails>>>()
        return response.result
//        return response.movies?.map { it.map(getImageUrl()) }
    }

    suspend fun getCartoons(
        page: Int,
        count: Int = 20
    ): List<VideoDetails>? {
        val response = httpClient.get(urlString = "cartoon/popular") {
            parameter("page", page)
            parameter("language", local)
            parameter("count", count)
        }.body<VideoResult<List<VideoDetails>>>()
        return response.result
    }

    suspend fun getCartoonsTV(
        page: Int,
        count: Int = 20
    ): List<VideoDetails>? {
        val response = httpClient.get(urlString = "cartoon/tv/popular") {
            parameter("page", page)
            parameter("language", local)
            parameter("count", count)
        }.body<VideoResult<List<VideoDetails>>>()
        return response.result
    }

    suspend fun searchData(query: String, page: Int): SearchResponse? {
        return httpClient.get(urlString = "search/all") {
            parameter("page", page)
            parameter("language", local)
            parameter("query", query)
        }.body<SearchResponse>()
    }

    suspend fun getPersonDetails(personId: Int): PersonDetails? {
        val response = httpClient.get(urlString = "person/details") {
            parameter("personId", personId)
            parameter("language", local)
        }.body<VideoResult<PersonDetails>>()
        return response.result
    }

    suspend fun getPersonCredits(personId: Int): List<VideoDetails>? {
        val response = httpClient.get(urlString = "person/credits") {
            parameter("personId", personId)
            parameter("language", local)
        }.body<VideoResult<List<VideoDetails>>>()
        return response.result
    }

    suspend fun identifyText(description: String): List<VideoDetails> {
        val response = httpClient.post(urlString = "identify/text") {
            setBody(
                IdentifyTextRequest(
                    description = description,
                    language = local,
                )
            )
        }.body<IdentifyTextResponse>()
        return response.candidates.map { it.video }
    }

    suspend fun getGenreList(): List<Genre> {
        return httpClient.get(urlString = "movie/genres").body<List<Genre>>()
    }
}

private fun getImageUrl(): String {
    val quality = "w500" // original
    return "https://image.tmdb.org/t/p/$quality/"
}